
window.LeftNavWhenOpen = '350';                 //Largeur du menu ouvert
window.LeftNavCloseDesktop = '59px';            //Largeur du menu fermé en desktop
window.LeftNavCloseMobile = '0';                //Largeur du menu en mobile
window.CalRdv = new Array();                    //Matrice qui contient les plages horaires du calendrier des rendez-vous
window.CurrentSelectedDay = {};                 //Jour sélectionné dans le calendrier
window.RDVDispo = {};                           //Matrice contenant les disponibilités de rendez-vous
window.CalCurrentDate = {};                     //Date courante du calendrier des RDV
window.ServerOK = false;                        //Serveur en ligne ou non
window.currentCodeCollecte = {};                //Code de collecte actif
window.deferredPrompt = {};                     //utilisé dans la mécanique d'ajout sur homescreen de Android
window.ignore_onbeforeunload = false;           //Va permettre d'ignore l'événement beforeonload qui affiche le loader dans certains cas, exemple les liens tel: ou mail:
window.gaRDV3 = false;                          //indicateur pour l'étape 3 de la prise de RDV de Google Analytics qui ne doit être déclenché qu'une seule fois
window.gaRDV4 = false;                          //indicateur pour l'étape 4 de la prise de RDV de Google Analytics qui ne doit être déclenché qu'une seule fois
window.currentPos = {};                         //position actuelle de l'utilisateur
window.myAddress = {};                          //Adresse pour centrer la carte des collectes
window.gotPos = false;                          //Flag si on a la position de l'utilisateur
window.distances = [];                          //Matrices qui contient les distances des collectes de la position actuelle de l'utilisateur
window.markers = [];                            //Matrice qui  contiens les marqueurs de carte des collectes
window.marker = {};                             //objet marqueur pour la création des marqueurs pour la carte des collectes
window.filterApplied = {};                      //config du filtre de collecte appliqué
window.currentFilterDate = {};                  //date active du filtre des collecte
window.currentFilterWeek = {};                  //semaine active du filtre des collectes
window.currentLocation = {};                    //localisation active du filtre des collectes
window.currentTypeCol = {};                     //type de collecte actif
window.allCollectes = [];                       //Les infos de toutes les collectes à afficher
window.colDistCalc = 0;                         //indicateur du nombre de distance calculée (de la localisation)
window.bottomControlOpen = false;               //indique si le panneau de controle des boutons du panneau latéral de droite est ouvert ou non 
window.ActiveCol = {};                          //collecte active
window.ActiveRDV = {};                          //rendez-vous actif dans le cas d'une modification
window.filterResult = false;                    //Si la distance la collecte est plus petite que la distance du filtre pour affichage des marqueurs dans la carte
window.currentType = 'sang';                    //type de don actif
window.currentTypeFormat = 'liste';             //type d'affichage des collectes actif
window.typeColor = 'white';                     //couleur selon le type de collecte
window.loaderTimeOut = {};                      //Timeout de l'indicateur de chargement
window.fromMyRDVCancel = false;                 //indique si la demande d'annulation d'un RDV proviens de la page "Mes RDV"
window.googleAutocomplete = {};                 //objet Google d'auto complétion des adresses
window.selectedLocation = '';                   //emplacement choisi par l'utilisateur
window.noDispoForMonth = true;                  //indique si aucune dispo pour le mois sélectionné
window.collecteObjToValidate = [];              //matrice de la liste des collectes à valider au chargement du cache
window.collecteValidationResult = true;         //résultat de la validation de la liste des collectes
window.clicked = false;                         //flag pour empêcher le double click
//window.calUpdateRunning = false;                //indique si le calcul du calendrier est en cours
window.calInitDone = false;                     //indique si le calendrier est initialisé
window.viewIntervalStart = {};                  //La date de la période visible du calendrier


window.NoRDVBtn = false; //Indique si le bouton prendre un rdv est visible dans le détail de la collecte
window.targetElement = document.querySelector("#MainAppContainer");

window.ProprieteCollecte = [
    {
        nom: 'accesDonneur',
        format: 'string'
    },
    {
        nom: 'afficherAdresse',
        format: 'boolean'
    },
    {
        nom: 'annule',
        format: 'boolean'
    },
    {
        nom: 'arrondissement',
        format: 'string'
    },
    {
        nom: 'codeCollecte',
        format: 'string'
    },
    {
        nom: 'collecteComplete',
        format: 'boolean'
    },
    {
        nom: 'collecteMultiJourID',
        format: 'string'
    },
    {
        nom: 'collectePrefere',
        format: 'boolean'
    },
    {
        nom: 'coordonnéesComplet',
        format: 'string'
    },
    {
        nom: 'dateDebut',
        format: 'string'
    },
    {
        nom: 'dateFin',
        format: 'string'
    },
    {
        nom: 'displayCulture',
        format: 'string'
    },
    {
        nom: 'distance',
        format: 'string'
    },
    {
        nom: 'emplacement',
        format: 'string'
    },
    {
        nom: 'emplacementPorteEtageLocal',
        format: 'string'
    },
    {
        nom: 'firstCenter',
        format: 'boolean'
    },
    {
        nom: 'halteGarderie',
        format: 'boolean'
    },
    {
        nom: 'id',
        format: 'string'
    },
    {
        nom: 'imageFile',
        format: 'string'
    },
    {
        nom: 'latitude',
        format: 'string'
    },
    {
        nom: 'lieu',
        format: 'string'
    },
    {
        nom: 'listCollecteHeure',
        format: 'object'
    },
    {
        nom: 'longitude',
        format: 'string'
    },
    {
        nom: 'mapLink',
        format: 'string'
    },
    {
        nom: 'municipalite',
        format: 'string'
    },
    {
        nom: 'municipaliteProvinceCP',
        format: 'string'
    },
    {
        nom: 'stationnement',
        format: 'string'
    },
    {
        nom: 'stationnementDonneur',
        format: 'boolean'
    },
    {
        nom: 'stationnementDonneurTarif',
        format: 'number'
    },
    {
        nom: 'telephoneAfficher',
        format: 'string'
    },
    {
        nom: 'telephoneClickToCall',
        format: 'string'
    },
    {
        nom: 'titre',
        format: 'string'
    },
    {
        nom: 'transportCommun',
        format: 'boolean'
    },
    {
        nom: 'typeCollecte',
        format: 'number'
    },
    {
        nom: 'typeCollecteRendezVous',
        format: 'number'
    },
    {
        nom: 'typeDon',
        format: 'number'
    }


];



